$(function () {
    function initAccordion(trigger, activeItemFirst, activeItemClass, hideItemFirst) {
        trigger.on('click', function H() {
            let self = $(this);
            trigger.not(self).siblings()
                .slideUp(400);
            self.parent().siblings().removeClass(`${activeItemClass}`);
            if (self.parent().hasClass(`${activeItemClass}`)) {
                self.siblings().slideUp(400);
                self.parent().removeClass(`${activeItemClass}`);
            } else {
                $(this).siblings()
                    .slideDown(400);
                $(this).parent().addClass(`${activeItemClass}`);
            }
        });

        if (!hideItemFirst) {
            if (activeItemFirst) {
                activeItemFirst.first().find(trigger)
                    .siblings()
                    .slideDown(400);
                activeItemFirst.first().addClass(`${activeItemClass}`);
            }
        }
    }

    $('.js-faq-accordion').each(function () {
        let $accordion = $(this),
            $trigger = $accordion.find('.js-trigger-faq-accordion'),
            $item = $accordion.find('.js-accordion-faq-item');

        initAccordion($trigger, $item, 'active', true);
    });

    /**
     * Tabs FAQ
     */
    
    $('.js-faq-tabs').each(function() {
        const $container = $(this);
        const $buttons = $container.find('.js-faq-tab-btn');
        const $contents = $container.find('.js-faq-tab-content');

        $buttons.on('click', function() {
            const $btn = $(this);
            const targetId = $btn.data('tab');
            if ($btn.hasClass('is-active')) return;

            const $targetContent = $('#' + targetId);

            // Update Buttons
            $buttons.removeClass('is-active');
            $btn.addClass('is-active');

            // Update Content
            $contents.fadeOut(200).removeClass('is-active');
            $targetContent.fadeIn(400).addClass('is-active');
        });
    });
});